import { render, staticRenderFns } from "./PermissionsCard.vue?vue&type=template&id=3b7ea65a&scoped=true"
import script from "./PermissionsCard.vue?vue&type=script&lang=js"
export * from "./PermissionsCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionsCard.vue?vue&type=style&index=0&id=3b7ea65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ea65a",
  null
  
)

export default component.exports